import routerOptions0 from "/var/lib/jenkins/workspace/nche-rie-build-intrafocus_master/frontend/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@22.14.1_db0@0.3.1_eslint@9.23.0_jiti@2.4.2__ior_er7nr7yyjovnvzz4555ixnh43i/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}